import { twMerge } from "tailwind-merge";
import { Type } from "@shared/ui/Type";
import { RequirementCheck } from "@shared/ui/RequirementCheck";

export type Props = {
  className?: string;
  validHoursCount: number;
};

export function SchedulingRequirements({ className, validHoursCount }: Props) {
  return (
    <div className={twMerge("flex flex-col gap-4 px-4", className)}>
      <Type variant="h4">Requirements</Type>
      <RequirementCheck
        isMet={validHoursCount >= 10}
        message="Select at least 10 hours when you’ll be available."
      />
      <RequirementCheck
        isMet={validHoursCount >= 14}
        message="Get a better match: Add another 4 hours of availability (14 hours total)."
      />
      <RequirementCheck
        isMet={validHoursCount > 14}
        message="Get the best match possible: Select 14+ hours of availability."
      />
    </div>
  );
}

export default SchedulingRequirements;
